import { Tooltip, TooltipTrigger } from '@shopflo/ui'
import { TrendIndicator } from 'src/components/analytics/common/TrendIndicator'
import { ChartTitle, TooltipContent } from 'src/components/overview/ChartCard'
import { useMemo } from 'react'
import { formatINRShort } from 'src/lib/utils/analytics'

interface SummaryCardProps {
  title: string
  value: number | string
  change?: number
  isRupee?: boolean
  description: string
  isLoading: boolean
  isPercentage?: boolean
}

function SummaryCardSkeleton() {
  return (
    <div className='flex gap-2'>
      <div className='w-2/3 h-8 rounded-xl bg-gray-200 animate-pulse' />
      <div className='w-1/3 h-8 rounded-xl bg-gray-200 animate-pulse' />
    </div>
  )
}

const SummaryCard = ({ title, value, change, description, isLoading, isPercentage, isRupee }: SummaryCardProps) => {
  const formattedValue = useMemo(() => {
    if (isPercentage) {
      return `${value}%`
    } else if (isRupee) {
      return `₹${formatINRShort(Math.round((typeof value === 'string' ? parseFloat(value) : value) * 100) / 100)}`
    }
    return value
  }, [value, isPercentage, isRupee])

  return (
    <div className='bg-white p-4 rounded-xl border-[1px] border-b-[3px] border-solid border-gray-light'>
      {isLoading ? (
        <SummaryCardSkeleton />
      ) : (
        <>
          <div className='flex space-x-2 items-start text-carbon'>
            <Tooltip delayDuration={0}>
              <TooltipTrigger>
                <ChartTitle title={title} />
              </TooltipTrigger>
              <TooltipContent>{description}</TooltipContent>
            </Tooltip>
          </div>
          <div className='flex space-x-2 text-carbon mt-2'>
            <span className='text-2xl font-bold'>{formattedValue}</span>
            <span className='mt-auto mb-1'>
              {change ? <TrendIndicator value={change} formatter={value => `${Math.abs(value)}%`} /> : null}
            </span>
          </div>
        </>
      )}
    </div>
  )
}

export default SummaryCard
